import { render, staticRenderFns } from "./TaskSettings.vue?vue&type=template&id=a01d477a&scoped=true"
import script from "./TaskSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TaskSettings.vue?vue&type=style&index=0&id=a01d477a&scoped=true&lang=scss"
import style1 from "./TaskSettings.vue?vue&type=style&index=1&id=a01d477a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01d477a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/joinmc-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a01d477a')) {
      api.createRecord('a01d477a', component.options)
    } else {
      api.reload('a01d477a', component.options)
    }
    module.hot.accept("./TaskSettings.vue?vue&type=template&id=a01d477a&scoped=true", function () {
      api.rerender('a01d477a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/massEmail/massEmailTaskDetail/TaskSettings.vue"
export default component.exports